export const SET_PROGRAMS_FILTERS = 'SET_PROGRAMS_FILTERS';
export const SET_PROGRAMS_SORT = 'SET_PROGRAMS_SORT';
